import { createGenericListItemReducer } from "common/genericListItemReducer";
import { createGenericReducer } from "common/genericReducer";
import { mergeInNewPage } from "common/mergeInNewPage";
import reduceReducers from "reduce-reducers";
import {
  WIDGETS_PRODUCTS_RECEIVED,
  WIDGETS_REQUESTED,
  WIDGETS_REQUEST_FAILED,
  WIDGET_PRODUCT_BY_CODE_RECEIVED,
  WIDGET_PRODUCT_BY_CODE_REQUESTED,
  WIDGET_PRODUCT_BY_CODE_REQUEST_FAILED
} from "./widgetActions";

const createWidgetProductsReducer = () => {
  const customReducer = (state, action) => {
    switch (action.type) {
      case WIDGETS_PRODUCTS_RECEIVED:
        const { pageSize, pageNumber, total, items } = action;
        return mergeInNewPage(state, pageSize, pageNumber, total, items, i => i.code);
      default:
        return state;
    }
  };
  return createGenericReducer(WIDGETS_REQUESTED, null, WIDGETS_REQUEST_FAILED, null, customReducer);
};

export const widgetProducts = reduceReducers(
  createWidgetProductsReducer(),
  createGenericListItemReducer(
    WIDGET_PRODUCT_BY_CODE_REQUESTED,
    WIDGET_PRODUCT_BY_CODE_RECEIVED,
    WIDGET_PRODUCT_BY_CODE_REQUEST_FAILED
  )
);
